<div class="container-content" fxLayout="column">
  <xng-breadcrumb [separator]="separatorIconTemplate">
    <ng-container
      *xngBreadcrumbItem="
        let breadcrumb;
        let info = info;
        let first = first
      "
    >
      <i class="bi bi-info-circle-fill" *ngIf="info && info === 'info'" aria-label="Info"></i>
      <i class="bi bi-house-fill" *ngIf="info && info === 'home'" aria-label="Home"></i>
      <ng-container *ngIf="!first">{{
        breadcrumb | translate
      }}</ng-container>
    </ng-container>
  </xng-breadcrumb>

  <ng-template #separatorIconTemplate>
    <i class="bi bi-caret-right-fill"></i>
  </ng-template>

  <h1 class="fs-2 fw-bold">{{ headline | translate }}</h1>
  <app-exam-location-form></app-exam-location-form>
</div>
